export const alert = [
  {
    "Asset ID": "ASD-GSE-01CR01-PAC002",
    "Forecasted Replacement Date": "2028",
    "Asset Name": "Air Compressor",
    Zone: 1,
    Location: 1,
    "Forecasted Replacement Cost": "$19,565",
    "Forecasted Maintenance Cost": "$19,565",
  },
  {
    "Asset ID": "ASD-GSE-03CR02-PAC003",
    "Forecasted Replacement Date": "2026",
    "Asset Name": "Air Compressor",
    Zone: 1,
    Location: 1,
    "Forecasted Replacement Cost": "$35,506",
    "Forecasted Maintenance Cost": "$35,506",
  },
  {
    "Asset ID": "LSD-MWB-01WK13-PAC004",
    "Forecasted Replacement Date": "2029",
    "Asset Name": "Air Compressor",
    Zone: 2,
    Location: 1,
    "Forecasted Replacement Cost": "$8,565",
    "Forecasted Maintenance Cost": "$8,565",
  },
];
